define('viewModels/privileged/qm/GroupSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'services/groupService',
    'services/loggingService',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (_, Promise, ko, groupService, LOG, ViewModel) {
    'use strict';

    /**
     * The GroupSelector class.
     * @class
     */
    var GroupSelectorView = ViewModel.extend(function (groupsObservable, options) {
        var self = this;

        self.groups = groupsObservable;
        self.placeholderText = ko.i18n.renderString('groupSelectorView.placeholderText');
        self.isOpen = ko.observable(false);

        var lookupGroups = function (searchTerm) {

            var groupsPromise;
            if (searchTerm.length > 0) {
                var queryObject = {
                    pageSize: 25,
                    query: [{
                        fields:["name"],
                        value: searchTerm.trim(),
                        type:"CONTAINS",
                        operator:"AND"
                    }]
                };

                groupsPromise = groupService.searchGroups(queryObject)
                .then(function (response) {
                    return ko.toJS(response);
                });
            } else {
                groupsPromise = groupService.getGroups({pageSize: 25})
                .then(function (response) {
                    return ko.toJS(response.entities);
                });
            }

            return groupsPromise
                .then(function (filteredGroups) {
                    var unwrappedGroups = ko.unwrap(self.groups);

                    _.remove(filteredGroups, function(group){
                        var shouldRemove = !!_.find(unwrappedGroups, {"id": group.id});
                        if (!shouldRemove){
                            if (options && options.ignoredIds){
                                return _.includes(options.ignoredIds(), group.id);
                            }
                        }
                        return shouldRemove;
                    });

                    return filteredGroups;
                })
                .catch(function (error) {
                    LOG.error("Couldn't retrieve groups", { error: error });
                    return [];
                });
        };

        self.getGroups = function (searchTerm) {
            return lookupGroups(searchTerm);
        };

        if (_.isArray(self.groups())) {
            self.groups.extend({deepComparer: true, minLength: {params: 1, message: "agentSelectorView.noAgentsSelected"}});
        } else {
            self.groups.extend({required: true});
        }

    }, true /* pass args to extended class */);

    return GroupSelectorView;
});

